import MerchantOfRecordEntity from '../types/MerchantOfRecordEntity'

export const getIsPayAtPropertyMoR = (offer?: {merchantOfRecord?: string}) =>
  offer?.merchantOfRecord === MerchantOfRecordEntity.Hotel
